import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

export default class MyStableLink extends PureComponent {

  static propTypes = {
    hasSubscriptions: PropTypes.bool,
    saveSubscriptions: PropTypes.func
  }

  render() {
    const {
      hasSubscriptions = false,
      saveSubscriptions = () => {}
    } = this.props;

    if (!hasSubscriptions) {
      return <a className="my-stable-add-to-stable" id="my-stable-add-to-stable" onClick={ () => saveSubscriptions() }>Add to my stable</a>
    } else {
      return <a className="my-stable-already-in-stable">Following</a>
    }
  }
}



// WEBPACK FOOTER //
// ./modules/Common/containers/Subscriptions/MyStableLink.js